import { FinancialQuestionnaireTypesEnum, KnowledgeAndExperienceRedirectStepEnum } from '../../lib/enums';
import { IndividualExtendedInfoData } from '../../lib/models/enroll';
import { getIndividualQuestionnaireAnswerByType } from '../../lib/store/selectors';

export const getCurrentStepIndexByNoExperience = (
  isNoExperienceWithStock: boolean,
  currentStepIndex: number,
  isBackPress = false,
): number => {
  const SINGLE_STEP = 1;
  const hiddenNoStockSteps = [
    KnowledgeAndExperienceRedirectStepEnum.AverageVolumeOfTrades,
    KnowledgeAndExperienceRedirectStepEnum.AverageNumberOfTrades,
  ];

  if (isBackPress) {
    if (isNoExperienceWithStock
      && [KnowledgeAndExperienceRedirectStepEnum.TradingKnowledge, ...hiddenNoStockSteps].includes(currentStepIndex)) {
      return KnowledgeAndExperienceRedirectStepEnum.DoYouHaveExperience;
    }

    return currentStepIndex - SINGLE_STEP;
  }

  if (isNoExperienceWithStock
    && [KnowledgeAndExperienceRedirectStepEnum.DoYouHaveExperience, ...hiddenNoStockSteps].includes(currentStepIndex)) {
    return KnowledgeAndExperienceRedirectStepEnum.TradingKnowledge;
  }

  return currentStepIndex + SINGLE_STEP;
};
